module.exports = __webpack_public_path__ + "static/img/cpzx_nav_5@2x.72652b94.png";